(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maison-museum')) {
  customElements.define('maison-museum', class extends HTMLElement {
    disconnectedCallback() {
      if (this.querySelector('dialog')?.open) document.documentElement.style.overflow = this.previousOverflow || '';
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const selection = this.querySelector('.maison__selection');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open]');
        if (trigger && typeof dialog.showModal === 'function' && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
          event.preventDefault();
          this.trigger = trigger;
          selection.replaceChildren(this.querySelector(`template[data-piece="${trigger.dataset.open}"]`).content.cloneNode(true));
          this.previousOverflow = document.documentElement.style.overflow;
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
        if (event.target.closest('.maison__close')) dialog.close();
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right) dialog.close();
        }
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.trigger?.focus();
      });
      this.addEventListener('submit', async event => {
        if (!event.target.matches('.maison__form')) return;
        event.preventDefault();
        const form = event.target;
        if (form.dataset.busy) return;
        const button = form.querySelector('button');
        const error = form.querySelector('[role="alert"]');
        form.dataset.busy = 'true';
        button.disabled = true;
        button.textContent = 'Un instant…';
        error.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [{id: new FormData(form).get('id'), quantity: 1}]})
          });
          const data = await response.json();
          if (!response.ok) throw new Error(response.status === 422 ? 'Cette pièce ou la quantité demandée n’est plus disponible. Veuillez choisir une autre option.' : 'Impossible d’ajouter cette pièce pour le moment. Veuillez réessayer.');
          // Conserve le panier existant et la langue de la boutique.
          const checkout = document.createElement('form');
          checkout.method = 'post'; checkout.action = this.dataset.cartUrl;
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout';
          checkout.append(input); document.body.append(checkout); checkout.submit();
        } catch (failure) {
          error.textContent = failure instanceof TypeError ? 'La connexion a été interrompue. Veuillez réessayer.' : failure.message || 'Veuillez réessayer.';
          button.textContent = 'Continuer vers le paiement';
          button.disabled = false;
          delete form.dataset.busy;
        }
      });
    }
  });
}

/* Paint responds to this product only; navigation and purchase handlers stay intact. */
(() => {
  const initPaint = () => document.querySelectorAll('.museum .maison__piece').forEach(card => {
    if (!card.querySelector('.museum-paint-orbit') || card.dataset.paintReady) return;
    card.dataset.paintReady = 'true';
    let hovering = false, touching = false, keyboard = false, fadeTimer;
    const fingers = new Set();
    const update = () => {
      const active = hovering || touching || keyboard;
      clearTimeout(fadeTimer);
      card.classList.toggle('is-paint-active', active);
      if(active) card.classList.add('is-paint-running');
      else fadeTimer = setTimeout(() => card.classList.remove('is-paint-running'), 1900);
    };
    card.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { hovering = true; update(); } });
    card.addEventListener('pointerleave', event => { if(event.pointerType !== 'touch') { hovering = false; update(); } });
    // Touch events remain active when the browser takes over vertical scrolling.
    card.addEventListener('touchstart', event => {
      for(const touch of event.changedTouches) fingers.add(touch.identifier);
      touching = fingers.size > 0; update();
    }, {passive:true});
    ['touchend','touchcancel'].forEach(type => card.addEventListener(type, event => {
      for(const touch of event.changedTouches) fingers.delete(touch.identifier);
      touching = fingers.size > 0; update();
    }, {passive:true}));
    card.addEventListener('focusin', event => { keyboard = event.target.matches(':focus-visible'); update(); });
    card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget)) { keyboard = false; update(); } });
  });
  initPaint();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPaint, {once:true});
  document.addEventListener('shopify:section:load', initPaint);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-museum"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maison-museum')) {
  customElements.define('maison-museum', class extends HTMLElement {
    disconnectedCallback() {
      if (this.querySelector('dialog')?.open) document.documentElement.style.overflow = this.previousOverflow || '';
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const selection = this.querySelector('.maison__selection');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open]');
        if (trigger && typeof dialog.showModal === 'function' && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
          event.preventDefault();
          this.trigger = trigger;
          selection.replaceChildren(this.querySelector(`template[data-piece="${trigger.dataset.open}"]`).content.cloneNode(true));
          this.previousOverflow = document.documentElement.style.overflow;
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
        if (event.target.closest('.maison__close')) dialog.close();
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right) dialog.close();
        }
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.trigger?.focus();
      });
      this.addEventListener('submit', async event => {
        if (!event.target.matches('.maison__form')) return;
        event.preventDefault();
        const form = event.target;
        if (form.dataset.busy) return;
        const button = form.querySelector('button');
        const error = form.querySelector('[role="alert"]');
        form.dataset.busy = 'true';
        button.disabled = true;
        button.textContent = 'Un instant…';
        error.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [{id: new FormData(form).get('id'), quantity: 1}]})
          });
          const data = await response.json();
          if (!response.ok) throw new Error(response.status === 422 ? 'Cette pièce ou la quantité demandée n’est plus disponible. Veuillez choisir une autre option.' : 'Impossible d’ajouter cette pièce pour le moment. Veuillez réessayer.');
          // Conserve le panier existant et la langue de la boutique.
          const checkout = document.createElement('form');
          checkout.method = 'post'; checkout.action = this.dataset.cartUrl;
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout';
          checkout.append(input); document.body.append(checkout); checkout.submit();
        } catch (failure) {
          error.textContent = failure instanceof TypeError ? 'La connexion a été interrompue. Veuillez réessayer.' : failure.message || 'Veuillez réessayer.';
          button.textContent = 'Continuer vers le paiement';
          button.disabled = false;
          delete form.dataset.busy;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
